module.exports = __webpack_public_path__ + "static/media/screen.1bb9b61b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/screen.svg
// module id = 720
// module chunks = 0